import * as React from "react";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import styled, { createGlobalStyle } from "styled-components";
import { pagePadding } from "../styles/constants";
import insertCc8Header from "../utils/insertCc8Header";
import Cc8Header from "./Cc8Header";

// Third-party nodes appended to <body> (e.g. Pendo) must not add a page scrollbar
const LockDocumentScroll = createGlobalStyle`
  html,
  body {
    overflow: hidden;
  }
`;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

const StyledInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  ${pagePadding};
`;

export const ControlCenterContainer = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const [searchParams] = useSearchParams();
  const widgetParam = searchParams.get("widget");
  const isWidgetMode = widgetParam !== null && widgetParam !== "false";

  useEffect(() => {
    // assets injected on first load are sticky — re-insertion is blocked by the .cc8navbar guard (not expected to change after mount)
    insertCc8Header(isWidgetMode);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <StyledContainer>
      <LockDocumentScroll />
      {!isWidgetMode && <Cc8Header />}
      <StyledInnerContainer>{children}</StyledInnerContainer>
    </StyledContainer>
  );
};
